<template>
    <div class="quiz__campaign__endpoint_images-inner">
        <div v-if="images.length > 0" class="quiz__campaign__endpoint_images-carousel">
            <div class="swiper-wrapper">
                <div v-for="(image, image_key) in images" :key="image_key" :index="'image' + image_key" :image="image" class="swiper-slide carousel-item swiper-container">
                    <img :src="image.image_urls.large" :alt="image.alt_text" />
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <div class="quiz__campaign__endpoint_article-content-wrap">
            <div v-if="content.subtitle" class="quiz__campaign__endpoint_article-content subtitle">
                <p class="quiz__campaign__endpoint-pre-subtitle">{{ content.subtitle }}</p>
            </div>
            <div v-if="content.title" class="quiz__campaign__endpoint_article-content title">
                <h2 class="quiz__campaign__endpoint-title">{{ content.title }}</h2>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['content'],
    mounted(){
        let vm = this;
        this.images = this.content.data;
        $(document).ready(function(){
            vm.initImageSlider();
            setTimeout(()=>{
                vm.swiper.update();
            },500);
        })

    },
    methods: {
        initImageSlider() {
            let vm = this;
            vm.swiper = new Swiper('.quiz__campaign__endpoint_images-carousel', {
                direction: 'horizontal',
                centeredSlides: false,
                loop: false,
                slidesPerView: 4,
                slidesPerGroup: 4,
                watchSlidesProgress: true,
                grabCursor: true,
                speed: 500,
                roundLengths: true,
                autoplay: false,
                watchOverflow: true,
                spaceBetween: 25,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                 breakpoints: {
                    767: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        centeredSlides: true,
                        spaceBetween: 0
                    }
                }
            });
        }
    },
    data() {
        return {
            images: [],
            swiper: null
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/images.vue